import { Injectable } from '@angular/core';
import { API } from './api.service';
import { SearchService } from './search.service';
import * as _ from 'lodash';
import * as UrlPattern from 'url-pattern';
import { routes } from '../../app.routes';

@Injectable()
export class HelperService {
    constructor(private api: API, private searchService: SearchService) {
    }

    getDomainFromRoute(route: string) {
        route = route.substr(1, route.length);
        let trimmedRoute = route.substr(1, route.length);
        trimmedRoute = route.split('?q=')[0];
        let currentRoute: any = {};
        _.forEach(routes, (arrayItem) => {
            if (arrayItem.path) {
                let pattern = new UrlPattern(arrayItem.path);
                if (pattern.match(trimmedRoute)) {
                    currentRoute = arrayItem;
                    return false;
                }
            }
        });
        let pattern = new UrlPattern(currentRoute.path);
        let domainObj = {
            local_route: route,
            domain: '',
            object: pattern.match(trimmedRoute).id || pattern.match(trimmedRoute).artistSlug || pattern.match(trimmedRoute).songSlug
            || pattern.match(trimmedRoute).albumSlug || pattern.match(trimmedRoute).screenname || '',
            params: pattern.match(trimmedRoute),
            is_search: 0
        };
        if (route.includes('?q=')) {
            domainObj.is_search = 1;
        }
        if (currentRoute.data && currentRoute.data.domain) {
            domainObj.domain = currentRoute.data.domain;
        }

        // if this route was accessed by search
        if ((this.searchService.getLastSearch() && domainObj.object) && this.searchService.getLastSearch() == domainObj.object) {
            domainObj.domain = 'SE';
            domainObj.is_search = this.searchService.lastSavedSearchId;
        }
        this.searchService.setLastSearch('');
        this.searchService.lastSavedSearchId = 0;

        return domainObj;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/services/helper.service.ts